// UF-13: WhatsApp pre-announcements older than 48 h fold away.
//
// A draft delivery carries the announcement's `received_at`. An announcement
// often arrives the evening before its truck, or the truck comes a day late,
// so the window is 48 hours and NOT "today": last night's announcement for
// this morning's truck must stay one tap from Confirm. Anything older folds
// into a counted disclosure — never hidden without a trace, never deleted
// (clearing a draft is a separate, unapproved item).
//
// A row whose time cannot be read, or that is in the future, stays OPEN:
// the fold may only hide what it can prove is old.

export const ANNOUNCEMENT_OPEN_HOURS = 48

export function splitAnnouncementsByAge<T extends { received_at: string | null | undefined }>(
  drafts: readonly T[],
  nowMs: number,
  openHours: number = ANNOUNCEMENT_OPEN_HOURS,
): { recent: T[]; older: T[] } {
  const cutoff = nowMs - openHours * 3_600_000
  const recent: T[] = []
  const older: T[] = []
  for (const d of drafts) {
    const at = d.received_at ? new Date(d.received_at).getTime() : NaN
    if (Number.isFinite(at) && at < cutoff) older.push(d)
    else recent.push(d)
  }
  return { recent, older }
}
